import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import "./styles/maltora.css";
import "./styles/landing-base.css";
import "./styles/landing-layout.css";
import "./styles/landing-contact.css";
import "./styles/landing-home.css";
import "./styles/landing-pricing.css";
import "./styles/landing-trust.css";

type LandingRootProps = {
  children: React.ReactNode;
};

const scrollToTop = () => {
  window.scrollTo(0, 0);
  if (document.documentElement) document.documentElement.scrollTop = 0;
  if (document.body) document.body.scrollTop = 0;
};

export default function LandingRoot({ children }: LandingRootProps) {
  const { pathname, hash, key } = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "start" });
        return;
      }
    }

    scrollToTop();
  }, [pathname, hash, key]);

  useEffect(() => {
    if (hash) return;
    // Re-assert scroll after layout/images settle, in case browser
    // restored a previous scroll position post-render.
    const raf = requestAnimationFrame(scrollToTop);
    const timeout = window.setTimeout(scrollToTop, 0);
    return () => {
      cancelAnimationFrame(raf);
      window.clearTimeout(timeout);
    };
  }, [pathname, hash, key]);

  return <div className="maltora-landing">{children}</div>;
}
